module.exports = __webpack_public_path__ + "img/3clasificacion.7810d0eb.png";